"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.BurgerWrap = exports.AccountWrap = exports.LogoWrapper = exports.Text = exports.NavLink = exports.LogoLink = exports.LogoImage = exports.NavWrapper = exports.PrimaryMenuWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Layout = require("../../../../Layout");

var _Link = _interopRequireDefault(require("../../../../Link"));

var _MegaMenu = require("../../MegaMenu/MegaMenu.style");

var _mediaQueries = _interopRequireDefault(require("../../../../../styles/mediaQueries"));

var PrimaryMenuWrapper = (0, _styled.default)(_Layout.Container)({
  height: _MegaMenu.headerHeight,
  display: 'flex',
  alignItems: 'center'
});
exports.PrimaryMenuWrapper = PrimaryMenuWrapper;
var NavWrapper = (0, _styled.default)('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%'
});
exports.NavWrapper = NavWrapper;
var LogoImage = (0, _styled.default)(_rebass.Image)({
  display: 'block',
  width: 'auto'
});
exports.LogoImage = LogoImage;
var LogoLink = (0, _styled.default)(_Link.default)({
  // IE fix
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    order: '1'
  },
  img: {
    height: 'auto',
    width: '100%',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 576px)': {
      width: 'auto'
    }
  }
});
exports.LogoLink = LogoLink;
var NavLink = (0, _styled.default)(_Link.default)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      space = _ref$theme.space,
      globalNav = _ref$theme.globalNav,
      active = _ref.active;
  return {
    marginRight: space.large,
    span: {
      color: colors[globalNav.primaryLinksColor],
      // this is on purpose, see parent component for explanation
      borderBottomColor: active === 'true' ? colors[globalNav.primaryLinksColor] : 'transparent',
      fontSize: globalNav.primaryMenuLinkFontSize,
      lineHeight: globalNav.primaryMenuLinkLineHeight
    },
    '&:hover span': {
      color: colors[globalNav.primaryLinksColor],
      borderBottomColor: colors[globalNav.primaryLinksColor]
    }
  };
});
exports.NavLink = NavLink;
var Text = (0, _styled.default)('div')({
  width: 'auto'
});
exports.Text = Text;
var LogoWrapper = (0, _styled.default)('div')(function (_ref2) {
  var space = _ref2.theme.space;
  return _defineProperty({
    marginRight: space.xlarge
  }, _mediaQueries.default.medium, {
    marginRight: space.xxxlarge
  });
});
exports.LogoWrapper = LogoWrapper;
var AccountWrap = (0, _styled.default)('div')(function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      space = _ref4$theme.space;
  return _defineProperty({
    display: 'flex',
    alignItems: 'center',
    height: _MegaMenu.headerHeight,
    padding: "0 ".concat(space.base),
    borderLeft: "1px solid ".concat(colors.greydark),
    borderRight: "1px solid ".concat(colors.greydark)
  }, _mediaQueries.default.small, {
    padding: "0 ".concat(space.large)
  });
});
exports.AccountWrap = AccountWrap;
var BurgerWrap = (0, _styled.default)('div')(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      globalNav = _ref6$theme.globalNav,
      isNavOpen = _ref6.isNavOpen;
  return {
    color: colors[globalNav.burgerColor],
    opacity: isNavOpen ? '0' : '1',
    transition: 'all .3s ease',
    marginLeft: 'auto',
    '&:hover': {
      color: colors[globalNav.burgerColorHover]
    }
  };
});
exports.BurgerWrap = BurgerWrap;